const getRigName = (params) => params.row.friendly_name;
export default getRigName;
